export default "__VITE_ASSET__47f2cce0__"